module.exports = __webpack_public_path__ + "39ca296596c57c3776bafcb7b117f3ab.pdf";